import React from "react";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";

import { createStock, updateStock, removeStock } from "reducers/product";
import { setBreadcrumbs } from "reducers/view";

import ProductStockService from "services/product-stock";

class ProductItemStock extends React.Component {
  productStockService = new ProductStockService();

  constructor() {
    super(...arguments);

    this.props.setBreadcrumbs([
      { name: "Products", slug: "/products" },
      {
        name: `Product: ${this.currentItem.name}`,
        slug: `/products/${this.currentId}`,
      },
      {
        name: `Stock Group: ${this.currentGroupItem.name}`,
        slug: `/products/${this.currentId}/stock/${this.currentGroupId}`,
      },
    ]);
  }

  columns = {
    name: { name: "Name", noEdit: true },
    quantity: { name: "Quantity" },
  };

  get currentId() {
    return this.props.match.params.id ?? null;
  }

  get currentItem() {
    return this.props.product.find((item) => item.id === this.currentId);
  }

  get currentGroupId() {
    return this.props.match.params.group_id ?? null;
  }

  get currentGroupItem() {
    return this.props.productGroup.find(
      (item) => item.id === this.currentGroupId
    );
  }

  async onDelete(productStock) {
    const result = await this.productStockService
      .delete(productStock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.removeStock(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(productStock) {
    const result = await this.productStockService
      .update(productStock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.updateStock(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(productStock) {
    const result = await this.productStockService
      .create(productStock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.createStock(result.data);
      return result.data;
    }
    return false;
  }

  get stock() {
    return this.props.stock.map(({ id, name }) => ({
      id,
      name,
    }));
  }

  get data() {
    return this.stock.map((item) => ({
      ...this.getMyStockById(item.id),
      ...item,
    }));
  }

  get selected() {
    return this.myStocks.map((item) => item.stock_id);
  }

  get myStocks() {
    return this.props.productStock.filter(
      (item) => item.group_id === this.currentGroupId
    );
  }

  getMyStockById(stockId) {
    return this.myStocks.find((item) => item.stock_id === stockId);
  }

  getItemsToAdd(selection, data) {
    return selection
      .reduce(
        (agg, item) =>
          this.selected.filter((id) => id === item).length === 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => ({
        id: 0,
        ...data.find((item) => item.stock_id === id),
      }));
  }

  getItemsToEdit(selection, data) {
    return selection
      .reduce(
        (agg, item) =>
          this.selected.filter((id) => id === item).length > 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => ({
        ...this.getMyStockById(id),
        ...data.find((item) => item.stock_id === id),
      }));
  }

  getItemsToDelete(selection) {
    return this.selected
      .reduce(
        (agg, item) =>
          selection.filter((id) => id === item).length === 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => this.getMyStockById(id));
  }

  onSelection(selection, data) {
    data = data.map(({ id, quantity }) => ({
      group_id: this.currentGroupId,
      stock_id: id,
      quantity: quantity ?? 0,
    }));

    const toDelete = this.getItemsToDelete(selection);
    const toAdd = this.getItemsToAdd(selection, data);
    const toEdit = this.getItemsToEdit(selection, data);

    toEdit.forEach((item) => this.onEdit(item));
    toDelete.forEach((item) => this.onDelete(item));
    toAdd.forEach((item) => this.onAdd(item));
  }

  render() {
    return (
      <React.Fragment>
        <ZeeTable
          title="Stock"
          columns={this.columns}
          data={this.data}
          selected={this.selected}
          hasPagination={true}
          hasSearch={true}
          onRowClick={() => null}
          onRowDoubleClick={(item) => this.onRowDoubleClick(item)}
          hasSelection={true}
          hasMultipleSelection={true}
          orderBy="name"
          onSelectionConfirm={(selection, data) =>
            this.onSelection(selection, data)
          }
          isEditing={true}
          confirmText="Save"
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      productStock: state.product.stock.all,
      productGroup: state.product.group.all,
      stock: state.stock.all,
      product: state.product.all,
    };
  },
  { updateStock, createStock, removeStock, setBreadcrumbs }
)(ProductItemStock);
